import styled from "styled-components";
import { ScrollableContent } from "../../../talent/talent.styled";

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    border-bottom: 1px solid #e3e3e3;
    padding: 0.75rem;
    &:first-child {
        border-top: 1px solid #e3e3e3;
    }
`;

export const EditButton = styled.button`
    border: none;
    margin: 0;
    padding: 0;
    position: absolute;
    top: 0.5rem;
    right: 0.5rem;
    font-size: 1.2rem;
    background: none;
    color: ${({ theme }) => theme.colors.primaryBlue.main};
    &:hover {
        color: ${({ theme }) => theme.colors.secondaryBlue.main};
    }
`;

export const CommentContainer = styled.div`
    position: relative;
    margin: 0;
    padding: 0;
    padding-top: 1rem;
    overflow: "hidden";

    ${EditButton} {
        top: 0;
        right: 0;
    }

    ${ScrollableContent};
`;

export const Description = styled.div`
    margin: 0;
    padding: 0;
    border: none;
    width: 100%;
    overflow: hidden;
    * {
        color: #000 !important;
        margin: 0 !important;
    }
    
`;

export const Footer = styled.div`
    margin: 0;
    padding: 0;
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    width: 100%;
`;

export const LastEdited = styled.span`
    color: ${({ theme }) => theme.colors.secondaryBlue.main};
    font-size: 0.8rem;
    font-weight: bold;
`;

export const ShowAllButton = styled.button`
    border: none;
    background: transparent;
    color: ${({ theme }) => theme.colors.primaryBlue.main};
    font-weight: 700;
    font-size: .9rem;
    margin: 10px 0px;
    padding: 4px;
    border: 1px solid ${({ theme }) => theme.colors.primaryBlue.main};
    border-radius: 8px;
`;

export const ShowAllContainer = styled.div`
    display: flex;
    justify-content: start;
`;

export const SaveButton = styled.button`
    border: none;
    border-radius: 0.5rem;
    background-color: ${({ theme }) => theme.colors.primaryBlue.main};
    color: #fff;
    margin: 0;
    padding: 0.5rem;
    height: fit-content;

    &:hover {
        background-color: #6A4F8C;
    }
`;